import get from 'lodash/get';
import extend from 'lodash/extend';
import RxThumbnail from '@Services/RxThumbnail';
import * as FormatUtils from '@Services/FormatUtils';

function _getHistoryThumbnail(structure) {
  return RxThumbnail.getHistoryThumbnail(structure)
    .then((paths) => {
      const payload = {
        thumbnailPath: null,
        type: null,
      };

      if (paths.HISTORY_THUMBNAIL_SUBSTANCE) {
        extend(payload, {
          thumbnailPath: FormatUtils.formatPath(get(paths, 'HISTORY_THUMBNAIL_SUBSTANCE.url')),
          type: 'HISTORY_THUMBNAIL_SUBSTANCE',
        });
      } else if (paths.HISTORY_THUMBNAIL_REACTION) {
        extend(payload, {
          thumbnailPath: FormatUtils.formatPath(get(paths, 'HISTORY_THUMBNAIL_REACTION.url')),
          type: 'HISTORY_THUMBNAIL_REACTION',
        });
      }

      return payload;
    })
    .catch(Logger.error);
}

function _getAlertThumbnail(structure) {
  return RxThumbnail.getAlertThumbnail(structure)
    .then((paths) => {
      const payload = {
        thumbnailPath: null,
        type: null,
      };

      if (paths.ALERT_THUMBNAIL) {
        extend(payload, {
          thumbnailPath: FormatUtils.formatPath(get(paths, 'ALERT_THUMBNAIL.url')),
          type: 'ALERT_THUMBNAIL',
        });
      }

      return payload;
    })
    .catch(Logger.error);
}

// eslint-disable-next-line import/prefer-default-export,consistent-return
export const retrieveThumbnailPath = (structure, thumbnailType) => {
  // eslint-disable-next-line default-case
  switch (thumbnailType) {
    case 'history':
      return _getHistoryThumbnail(structure);
    case 'alert':
      return _getAlertThumbnail(structure);
  }
};
